<template>
  <div class="help">
    <nav-pc tips="1" />
    <!-- 服務條款	 id = 3 -->
    <div class="content">
      <van-nav-bar
        :title="lang.ServiceTit"
        :left-arrow="!$route.query.fromapp"
        class="navBar"
        @click-left="close"
      />
      <p
        class="text"
        v-html="lang.Service"
      />
    </div>
  </div>
</template>

<script>
import pub from '../../common/public';
import navPc from './../components/navBar-pc';
import lang from './../../common/language/disclaimer';
export default {
  name: 'Disclaimer',
  components: {
    navPc,
  },
  data() {
    return {
      lang,
      title: '',
      isPc: false,
    };
  },
  created() {
    this.isPc = !(document.body.clientWidth <= 750 || /mobi|android|iphone|blackberry|ipod|iemobile/i.test(navigator.userAgent.toLocaleLowerCase()))
    if (this.isPc) {
      if (pub.getLang() === 'zh-cn') {
        location.href = `${pub.config.pcUrl}zh-cn/help/disclaimer/`;
      } else if (pub.getLang() === 'en-us') {
        location.href = `${pub.config.pcUrl}en-us/help/disclaimer/`;
      } else {
        location.href = `${pub.config.pcUrl}help/disclaimer/`;
      }
    }
  },
  methods: {
    close() {
      window.history.go(-1);
    },
  },
  metaInfo() {
    return {
      title: this.title,
    };
  },
};
</script>

<style lang="scss" >
@media screen and (min-width: 601px) {
  .navBar {
    display: none;
  }
  .content {
    padding: 30px 0px;
    margin: auto;
    width: 990px;
  }
}
.center {
  text-align: center;
}
a.hrefs:link,
a.hrefs:visited,
a.hrefs:active {
  color: #2c3e50;
}
.imgViewHelp {
  width: 153px;
  height: 14px;
  display: inline-block;
  background-image: url(../assets/email.png);
}
.text {
  line-height: 21px;
  font-size: 14px;
  padding: 18px;
}
#ul {
  list-style-type: disc !important;
}
.blod {
  font-weight: 600;
}
.help {
  font-size: 15px;
  text-align: left;
  line-height: 20px;
}

.van-nav-bar {
  border-bottom: 1px solid #e3e4e6;
  background-color: #fafbfc;
}
.van-nav-bar__title {
  font-size: 17px;
  font-weight: 600;
}
.van-nav-bar__text {
  color: #333;
}
.van-nav-bar .van-icon {
  font-size: 25px;
  color: black;
}
</style>
